// src/components/layout/Footer.jsx
import React from 'react';
import { useTranslation } from '../../i18n';

const Footer = () => {
  const { t } = useTranslation();

  // ... le reste du code

  return (
    <footer className="bg-ofd-slate pt-12 pb-0 relative">
      {/* ... */}
      <div className="flex items-center gap-3">
        <img 
          src="/logo.jpeg"  // ✅ CORRIGÉ - sans /public/
          alt="Logo OFD"
          className="h-16 w-16 rounded-full object-cover border-2 border-ofd-yellow"
        />
        {/* ... */}
      </div>
      {/* ... */}
    </footer>
  );
};

export default Footer;